"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Era = void 0;
var Era;
(function (Era) {
    Era["Byron"] = "byron";
    Era["Shelley"] = "shelley";
    Era["Allegra"] = "allegra";
    Era["Mary"] = "mary";
    Era["Alonzo"] = "alonzo";
    Era["Babbage"] = "babbage";
})(Era = exports.Era || (exports.Era = {}));
Object.freeze(Era);
